"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamImage = exports.TeamImageDefaultProps = exports.TeamBannerPhotoGridProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_photo_grid_1 = require("./person-photo-grid");
var lodash_1 = require("lodash");
var router_1 = require("@reach/router");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
// -------- Types -------->
exports.TeamBannerPhotoGridProps = {
  small: {
    rows: 1,
    columns: 3,
    size: 48,
    spacing: -24
  },
  embed: {
    rows: 2,
    columns: 4,
    size: 36,
    spacing: 8
  },
  medium: {
    rows: 2,
    columns: 3,
    size: 36,
    spacing: 8
  },
  large: {
    rows: 3,
    columns: 3,
    size: 56,
    spacing: 16
  },
  veryLarge: {
    rows: 3,
    columns: 5,
    size: 80,
    spacing: 16
  }
};
exports.TeamImageDefaultProps = {
  size: 'medium'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n    text-decoration: none;\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    padding: ", ";\n    text-decoration: none;\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(4), function (_a) {
    var bannerSize = _a.bannerSize;
    return bannerSize === 'small' && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4));
  }, function (_a) {
    var blended = _a.blended;
    return blended && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-top: 0;\n    "], ["\n      padding-top: 0;\n    "])));
  }, function (_a) {
    var isCell = _a.isCell;
    return isCell && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: 0;\n    ", "\n  "], ["\n    padding-right: 0;\n    ", "\n  "])), function (_a) {
    var isCell = _a.isCell;
    return isCell && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  })
});
var OuterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    padding-right: ", ";\n\n    a {\n      text-decoration: none;\n    }\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Outer: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OuterStyles),
  Container: (0, styled_components_1.default)(person_photo_grid_1.PersonPhotoGrid)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var TeamImage = function (props) {
  var className = props.className,
    entity = props.entity,
    size = props.size,
    blended = props.blended,
    isCell = props.isCell,
    isBanner = props.isBanner;
  var people = (0, lodash_1.filter)((entity.members || []).map(function (member) {
    return member.person;
  }));
  var gridProps = exports.TeamBannerPhotoGridProps[isCell ? 'small' : size];
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var to = defn && defn.to(entity.slug, 'team-roles');
  var inner = !!people.length && react_1.default.createElement(My.Container, __assign({
    isCell: !!isCell,
    blended: blended,
    bannerSize: size,
    size: size,
    people: people
  }, gridProps, {
    className: className
  }));
  return react_1.default.createElement(My.Outer, null, isBanner ? react_1.default.createElement(router_1.Link, {
    to: to
  }, inner) : inner);
};
exports.TeamImage = TeamImage;
exports.TeamImage.defaultProps = exports.TeamImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;